const getPositionCss = (position) => {
  switch (position) {
    case 'center':
    case 'center-center': return 'top: 50%; left: 50%; transform: translate(-50%, -50%);';
    case 'center-left': return 'top: 50%; left: 5%; transform: translate(0, -50%);';
    case 'center-right': return 'top: 50%; right: 5%; transform: translate(0, -50%);';

    case 'top':
    case 'top-center': return 'top: 5%; left: 50%; transform: translate(-50%, 0);';
    case 'top-left': return 'top: 5%; left: 5%;';
    case 'top-right': return 'top: 5%; right: 5%;';

    case 'bottom':
    case 'bottom-center': return 'bottom: 5%; left: 50%; transform: translate(-50%, 0);';
    case 'bottom-left': return 'bottom: 5%; left: 5%;';
    case 'bottom-right': return 'bottom: 5%; right: 5%;';
    default: throw new Error('Unhandled position in getPositionCSS');
  }
};

function getAbsolutePositionCSS(position) {
  return `position: absolute; ${getPositionCss(position)}`;
}

export default getAbsolutePositionCSS;
